import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import CustomSelect from "../../../../../Components/CustomSelect";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchSLA,
  fetchOrganisation,
} from "../../../Admin/Reports/SLA/redux/SLAService";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import FileDownloadIcon from "@material-ui/icons/ArrowDownward";
import Dialog from "@material-ui/core/Dialog";
import { ThemeProvider, withStyles } from "@material-ui/core/styles";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DataService from "../../../../../Service";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { fontTheme } from "../../../../../fontTheme";
import { utils, writeFile, write } from "xlsx";
import logoImage from "../../../../../Images/acuity-logo.png";
import clientLogoDemo from "../../../../../Images/demo_client_new_logo.png";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import useDownloads from "../useDownloads";
const useStyles: any = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "500px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "capitalize",
  },
  dialog_title: {
    marginLeft: "1.5rem",
    "& h6": {
      fontWeight: "700",
      fontSize: "18px",
      fontFamily: "Open Sans",
    },
  },
  headerClass: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  bottom: {
    color: "#e3e3e3",
  },
  top: {
    color: "yellow",
    animationDuration: "550ms",
    position: "absolute",
    left: 0,
  },
  circle: {
    strokeLinecap: "round",
  },
}));

const styles: any = (theme: any) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

interface ISlaData {
  compliance: number;
  description: any;
  exceptions: [];
  id: number;
  measure: string;
  number_of_assignmnet: number;
}

const SLA: React.FC<any> = (props) => {
  const classes = useStyles();
  let role = sessionStorage.getItem("role");
  const [userData, setUserData] = useState<any>({ organisation: "All" });
  const [orgData, setOrgData] = useState<any>([]);
  const organisation_id = sessionStorage.getItem("organisation_id");

  const [orgId, setOrgaId] = useState<any>(
    role === "admin" ? undefined : organisation_id
  );
  const [exceptionModal, setExceptionModal] = useState<boolean>(false);
  const [currentSelection, seCurrentSelection] = useState<any>(undefined);
  const dispatch: any = useDispatch();
  const slaData = useSelector((state: any) => state?.reportSLA);
  const onChangeItem = (selectedItemValue: any) => {
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
    const localArr: any = orgData.filter(
      (option: any) =>
        option.organisation_name == selectedItemValue.value && option
    );
    var orgId = localArr.length > 0 ? localArr[0].id : "";
    setOrgaId(orgId);
    dispatch(fetchSLA(orgId));
  };
  // Download pdf,xlsx,csv logic
  let fileName = `${
    userData.organisation === "All" ? "" : userData.organisation + "_"
  }Collated SLA`;

  const getData = () => {
    const param: any = {};
    if (orgId) {
      param["organisation_id"] = orgId;
    }
    return DataService.getData(param, "report_fetch_sla");
  };
  const columns: any = [
    { field: "description", title: "Description" },
    { field: "measure", title: "Measure" },
    { field: "compliance", title: "Compliance" },
    { field: "number_of_assignmnet", title: "Number of Assignments" },
    { field: "exceptions", title: "Exceptions" },
  ];
  const { downloading, downloadingOption, exportPDF, exportCsv, exportXLSX } =
    useDownloads({
      columns,
      getData,
      listKey: "sla_list",
      userData: {
        organisation:
          role === "admin" ? userData.organisation : organisation_id,
      },
      role,
      fileName,
      columnStyles: { 2: { halign: "center" }, 3: { halign: "center" } },
    });

  //
  useEffect(() => {
    setOrgData(slaData?.organisationData);
  }, [slaData]);

  useEffect(() => {
    dispatch(fetchOrganisation());
    dispatch(fetchSLA(orgId || undefined));
  }, [dispatch]);

  const DialogTitle: any = withStyles(styles)((props: any) => {
    const { children, classes, onClose, ...other } = props;

    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h2">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  const viewDetails = () => {
    return (
      <Dialog
        open={exceptionModal}
        onClose={() => {
          setExceptionModal(false);
        }}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle
          id="customized-dialog-title"
          className={classes.dialog_title}
        >
          {"Exceptions"}
        </DialogTitle>
        <Divider />
        <>
          <ThemeProvider theme={fontTheme}>
            <DialogContent style={{ margin: "0px auto" }}>
              <div className={classes.formWrapper}>
                {currentSelection?.exceptions?.length > 0 ? (
                  currentSelection?.exceptions?.map((data: any) => {
                    if (!data) {
                      return (
                        <Typography variant="h2" gutterBottom>
                          {"No data found"}
                        </Typography>
                      );
                    } else {
                      return (
                        <ul>
                          <li>
                            <Typography variant="h5" gutterBottom>
                              {data}
                            </Typography>
                          </li>
                        </ul>
                      );
                    }
                  })
                ) : (
                  <Typography variant="h2" gutterBottom>
                    {"No data found"}
                  </Typography>
                )}
              </div>
            </DialogContent>{" "}
          </ThemeProvider>
        </>
      </Dialog>
    );
  };

  function CircularProgressWithLabel(props: any) {
    return (
      <Box position="relative" display="inline-flex">
        <div style={{ position: "relative" }}>
          <CircularProgress
            variant="determinate"
            className={classes.bottom}
            size={50}
            thickness={4}
            value={100}
          />
          <CircularProgress
            variant="determinate"
            disableShrink
            className={classes.top}
            classes={{
              circle: classes.circle,
            }}
            size={50}
            thickness={4}
            {...props}
          />
        </div>
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            variant="caption"
            component="div"
            color="textSecondary"
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    );
  }

  const downloadXls = () => {
    DataService.getData(
      { organisation_id: orgId, csv: true },
      "report_fetch_sla"
    )
      .then((res) => {
        window.location.assign(res.file);
      })
      .catch((error) => {
        dispatch(showSnackbar("error", ["No data found!"]));
      });
  };

  return (
    <Box py={1}>
      <ThemeProvider theme={fontTheme}>
        {
          <Grid container direction="row">
            <Grid item xs={12}>
              <Grid container direction="row" className={classes.headerClass}>
                {role === "admin" ? (
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      style={{ color: "#EF7000", marginTop: 10 }}
                    >
                      <Box mb={1} fontWeight="fontWeightBold">
                        Select organization
                      </Box>
                    </Typography>
                    <CustomSelect
                      id="organisation"
                      labelText="Select organization"
                      variant="outlined"
                      itemArr={[
                        "All",
                        ...orgData.map(
                          (option: any) => option.organisation_name
                        ),
                      ]}
                      parentcall={onChangeItem}
                      defaultValue={userData.organisation}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={6}></Grid>
                )}
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    gap: "0.5rem",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    color="primary"
                    disabled={!slaData?.SLAData?.length}
                    style={{
                      textTransform: "inherit",
                      float: "right",
                      marginTop: "18px",
                      width: "170px",
                    }}
                    variant="contained"
                    onClick={exportXLSX}
                  >
                    {downloading && downloadingOption === "xlsx" ? (
                      <CircularProgress
                        size={22}
                        style={{ marginRight: "5px", color: "white" }}
                      />
                    ) : (
                      <FileDownloadIcon style={{ marginRight: "5px" }} />
                    )}
                    Download xlsx
                  </Button>

                  <Button
                    color="primary"
                    disabled={!slaData?.SLAData?.length}
                    style={{
                      textTransform: "inherit",
                      float: "right",
                      marginTop: "18px",
                      width: "170px",
                    }}
                    variant="contained"
                    onClick={exportCsv}
                  >
                    {downloading && downloadingOption === "csv" ? (
                      <CircularProgress
                        size={22}
                        style={{ marginRight: "5px", color: "white" }}
                      />
                    ) : (
                      <FileDownloadIcon style={{ marginRight: "5px" }} />
                    )}{" "}
                    Download csv
                  </Button>

                  <Button
                    color="primary"
                    disabled={!slaData?.SLAData?.length}
                    style={{
                      textTransform: "inherit",
                      float: "right",
                      marginTop: "18px",
                      width: "170px",
                    }}
                    variant="contained"
                    onClick={exportPDF}
                  >
                    {downloading && downloadingOption === "pdf" ? (
                      <CircularProgress
                        size={22}
                        style={{ marginRight: "5px", color: "white" }}
                      />
                    ) : (
                      <FileDownloadIcon style={{ marginRight: "5px" }} />
                    )}{" "}
                    Download pdf
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
        <Grid
          container
          direction="row"
          spacing={2}
          alignItems="center"
          style={{
            marginTop: 20,
            borderWidth: 1,
            borderColor: "#ddd",
            borderStyle: "solid",
            padding: 14,
          }}
        >
          <Grid item xs={3}>
            <Typography variant="h2" style={{ color: "#077F83" }}>
              <Box fontWeight="fontWeightBold">Description</Box>
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h2" style={{ color: "#077F83" }}>
              <Box fontWeight="fontWeightBold">Measure</Box>
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="h2" style={{ color: "#077F83" }}>
              <Box fontWeight="fontWeightBold">Compliance</Box>
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="h2" style={{ color: "#077F83" }}>
              <Box fontWeight="fontWeightBold">Number of assignments</Box>
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="h2" style={{ color: "#077F83" }}>
              <Box fontWeight="fontWeightBold">Exceptions</Box>
            </Typography>
          </Grid>
        </Grid>
        <Box>
          {slaData?.SLAData?.length > 0 ? (
            slaData?.SLAData?.map((option: ISlaData) => {
              return (
                <>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    style={{
                      marginTop: 7,
                      borderWidth: 1,
                      borderColor: "#ddd",
                      borderStyle: "solid",
                      padding: 12,
                    }}
                  >
                    <Grid item xs={3}>
                      <Typography variant="h2" style={{ color: "#320032" }}>
                        <Box>{option?.description || "-"}</Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography variant="h2" style={{ color: "#320032" }}>
                        <Box>{option?.measure || "-"}</Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={2} alignContent="center">
                      <CircularProgressWithLabel
                        thickness={4}
                        variant="determinate"
                        value={option?.compliance || 0}
                        style={{
                          color: role == "admin" ? "#EF7000" : "#EF7000",
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="h2" style={{ color: "#320032" }}>
                        <Box>{option?.number_of_assignmnet || "-"}</Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="h2">
                        <Box>
                          <Link
                            onClick={() => {
                              seCurrentSelection(option);
                              setExceptionModal(true);
                            }}
                            style={{
                              cursor: "pointer",
                              color: role == "admin" ? "#EF7000" : "#EF7000",
                            }}
                          >
                            View details
                          </Link>
                        </Box>
                      </Typography>
                    </Grid>
                  </Grid>
                  {/* <Divider /> */}
                </>
              );
            })
          ) : (
            <>
              <Grid
                container
                direction="row"
                spacing={2}
                alignItems="center"
                style={{
                  marginTop: 7,
                  borderWidth: 1,
                  borderColor: "#ddd",
                  borderStyle: "solid",
                  padding: 16,
                }}
              >
                <Grid item xs={3}>
                  <Typography variant="h2" style={{ color: "#320032" }}>
                    <Box>{"Record not found"}</Box>
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
        </Box>
      </ThemeProvider>
      {exceptionModal && viewDetails()}
    </Box>
  );
};

export default SLA;
